function initAllPostsGrid(block) {
    if (block.dataset.p7AllPostsGridInit) return;
    block.dataset.p7AllPostsGridInit = '1';

    const gridContainer = block.querySelector('.p7-all-posts-grid');
    const loadMoreBtn = block.querySelector('.p7-load-more');
    const pagination = block.querySelector('.p7-all-posts-grid-pagination');
    const searchInput = block.querySelector('.p7-search-input');
    const searchForm = block.querySelector('.p7-search-form');
    const searchBtn = block.querySelector('.p7-search-btn');

    const filterButtons = block.querySelectorAll('.p7-filter-btn');

    const attributes = JSON.parse(block.dataset.attributes || '{}');
    const ajaxurl = block.dataset.ajaxurl;
    const nonce = block.dataset.nonce;

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;
    let currentFilters = {};
    let searchQuery = '';

    /* -----------------------------
     * Equalize Title Heights
     * ----------------------------- */
    function equalizePostTitles() {
        const titles = block.querySelectorAll('.p7-post-title');
        let maxHeight = 0;

        titles.forEach(title => {
            title.style.height = 'auto';
            maxHeight = Math.max(maxHeight, title.offsetHeight);
        });

        titles.forEach(title => {
            title.style.height = maxHeight + 'px';
        });
    }

    function debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }

    if (searchForm && searchInput && searchBtn) {
        const debounceSearch = debounce(() => {
            searchQuery = searchInput.value.trim();
            searchBtn.textContent = 'Searching...';
            loadPosts(1, currentFilters);
        }, 400);

        // searchInput.addEventListener('input', debounceSearch);

        searchForm.addEventListener('submit', e => {
            e.preventDefault();
            debounceSearch();
        });

        searchBtn.addEventListener('click', e => {
            e.preventDefault();
            debounceSearch();
        });
    }


    /* -----------------------------
     * Load Posts (AJAX)
     * ----------------------------- */
    function loadPosts(page = 1, filters = {}) {
        if (isLoading) return;
        isLoading = true;
        currentPage = page;

        if (page === 1) gridContainer.style.opacity = '0';
        if (pagination) pagination.style.display = 'none';

        if (page === 1) gridContainer.innerHTML = '';

        const body = new URLSearchParams({
            action: 'p7_load_all_posts',
            nonce: nonce,
            page: page.toString(),
            postsPerPage: attributes.postsPerPage,
            filters: JSON.stringify(filters),
            search: searchQuery,
        });

        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
        })
            .then(res => res.json())
            .then(data => {
                if (!data.success) return;

                if (page === 1) gridContainer.innerHTML = data.data.html;
                else gridContainer.insertAdjacentHTML('beforeend', data.data.html);

                maxPages = data.data.max_pages;
                currentPage = data.data.current_page;

                if (loadMoreBtn) {
                    loadMoreBtn.style.display =
                        currentPage < maxPages ? 'flex' : 'none';
                }

                requestAnimationFrame(equalizePostTitles);
            })
            .catch(console.error)
            .finally(() => {
                isLoading = false;
                if (page === 1) gridContainer.style.opacity = '1';
                if (pagination) pagination.style.display = 'flex';

                if (searchBtn) searchBtn.textContent = 'Search';
                if (typeof AOS !== "undefined") {
                    requestAnimationFrame(() => {
                        AOS.refreshHard();
                    });
                }
            });
    }

    /* -----------------------------
     * Category Buttons Filter
     * ----------------------------- */
    filterButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();

            // Remove active from all buttons in the same container
            btn.parentElement.querySelectorAll('.p7-filter-btn')
                .forEach(b => b.classList.remove('is-active'));

            // Add active to clicked button
            btn.classList.add('is-active');

            const filterName = btn.dataset.filterName;
            const filterValue = btn.dataset.filterValue;

            // Update currentFilters object
            if (filterValue) currentFilters[filterName] = [filterValue];
            else delete currentFilters[filterName];

            // Reload posts with new filter
            loadPosts(1, currentFilters);
        });
    });

    /* -----------------------------
     * Load More Button
     * ----------------------------- */
    loadMoreBtn?.addEventListener('click', () => {
        loadPosts(currentPage + 1, currentFilters);
    });

    /* -----------------------------
     * Init
     * ----------------------------- */
    loadPosts();

    // Resize fix
    window.addEventListener('resize', () => {
        requestAnimationFrame(equalizePostTitles);
    });
}

/* -----------------------------
 * MutationObserver (AJAX + Blocks)
 * ----------------------------- */
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof Element)) return;

            if (node.classList.contains('p7-all-posts-grid-block')) {
                initAllPostsGrid(node);
            }

            node.querySelectorAll?.('.p7-all-posts-grid-block')
                .forEach(initAllPostsGrid);
        });
    });
});

if (document.body instanceof Element) {
    observer.observe(document.body, { childList: true, subtree: true });
}

/* -----------------------------
 * Initial Load
 * ----------------------------- */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.p7-all-posts-grid-block')
        .forEach(initAllPostsGrid);
});


function initCategoryScroll(containerSelector = '.p7-category-filters') {
    const containers = document.querySelectorAll(containerSelector);

    containers.forEach(container => {
        let isMouseOver = false;

        container.addEventListener('mouseenter', () => (isMouseOver = true));
        container.addEventListener('mouseleave', () => (isMouseOver = false));

        container.addEventListener('mousemove', e => {
            if (!isMouseOver) return;

            const { left, width } = container.getBoundingClientRect();
            const mouseX = e.clientX - left;
            const percent = mouseX / width; // 0 = left, 1 = right

            // max scrollLeft
            const maxScroll = container.scrollWidth - container.clientWidth;

            container.scrollLeft = percent * maxScroll;
        });
    });
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
    initCategoryScroll();
});


function enableDragScroll(containerSelector = '.p7-category-filters') {
    const containers = document.querySelectorAll(containerSelector);

    containers.forEach(container => {
        let isDown = false;
        let startX;
        let scrollLeft;

        container.addEventListener('mousedown', e => {
            isDown = true;
            container.classList.add('dragging');
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
        });
        container.addEventListener('mouseleave', () => (isDown = false));
        container.addEventListener('mouseup', () => (isDown = false));
        container.addEventListener('mousemove', e => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 2; // scroll-fast multiplier
            container.scrollLeft = scrollLeft - walk;
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    enableDragScroll();
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href^="#blog"]').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const href = link.getAttribute('href');
            const [hash, query] = href.split('?');
            const params = new URLSearchParams(query || '');
            const filterValue = params.get('filter');

            const newUrl = new URL(window.location);
            newUrl.hash = '';
            newUrl.searchParams.delete('filter');
            window.history.pushState({}, '', newUrl);

            if (filterValue) {
                const btn = document.querySelector(`.p7-filter-btn[data-filter-value="${filterValue}"]`);
                if (btn) btn.click();
            }

            const grid = document.querySelector('.p7-all-posts-grid');
            if (grid) {
                const y = grid.getBoundingClientRect().top + window.scrollY - 100; // offset -100px
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        });
    });
});

